import "bootstrap/scss/bootstrap.scss";

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSwal from "vue-swal";
import { auth, } from "./firebase";

import "bootstrap/dist/js/bootstrap.bundle";

Vue.config.productionTip = false;

Vue.use(VueSwal);

Vue.filter("date", value => {
  if (value)
    return value.toDate().toLocaleString("es-CO", { day: "numeric", month: "long", year: "numeric", });
  else
    return "---";
});

let app;

auth.onAuthStateChanged(async user => {
  if (user)
    await store.dispatch("SIGN_IN", user.uid);
  else
    store.commit("SET_USER", null);
  
  if (!app)
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
});
